import React from 'react';
import { UserStore } from '../baseUserStore';
import { UserStoreContext } from './userStoreContext';

interface UserStoreProviderProps {
  store: UserStore;
  children: React.ReactNode;
}

export const UserStoreProvider: React.FC<UserStoreProviderProps> = ({
  store,
  children,
}) => {
  return (
    <UserStoreContext.Provider value={store}>
      {children}
    </UserStoreContext.Provider>
  );
};
